import Navigation from '@/components/Navigation';
import MarketTicker from '@/components/MarketTicker';
import HeroSection from '@/components/HeroSection';
import InstrumentsSection from '@/components/InstrumentsSection';
import AdvantagesSection from '@/components/AdvantagesSection';
import PlatformsSection from '@/components/PlatformsSection';
import AccountsSection from '@/components/AccountsSection';
import DepositMethodsSection from '@/components/DepositMethodsSection';
import AwardsSection from '@/components/AwardsSection';
import TrustSection from '@/components/TrustSection';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <MarketTicker />
      <Navigation />
      <main>
        <HeroSection />
        <InstrumentsSection />
        <AdvantagesSection />
        <PlatformsSection />
        <AccountsSection />
        <DepositMethodsSection />
        <AwardsSection />
        <TrustSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;